import { AFFISE_CALLBACK_FETCHED_SUCCESS } from '../constants/actionTypes';

const initialState = {
  affiseCallbacks: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AFFISE_CALLBACK_FETCHED_SUCCESS:
      return {
        ...state,
        affiseCallbacks: action.payload.affiseCallbacks,
        pager: action.payload.pager,
      };
    default:
      return state;
  }
};
